module.exports = __webpack_public_path__ + "assets/OverviewData.cc7395a9.svg";